import React from 'react';
import { IconSort, IconSortUp, IconSortDown } from '.';

export const IconSortDynamic = (sort) => {
  if (sort.sorted) {
    if (sort.dir === 'ASC') {
      return (<IconSortUp />)
    } else {
      return (<IconSortDown />)
    }
  } else {
    return (
      <IconSort />
    );
  }
}
